import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ClassicCarQuoterStoreService } from '../../../store/classic-car-quoter-store.service';
import { ResumeItemComponent } from '@webapp/core/ui/components/resume-item/resume-item.component';
import { IResumeItem } from '@webapp/quoter/interfaces/quoter.interface';

@Component({
  selector: 'app-classic-car-resume',
  imports: [ResumeItemComponent],
  providers: [DatePipe, CurrencyPipe],
  templateUrl: './classic-car-resume.component.html',
  styleUrl: './classic-car-resume.component.scss',
})
export class ClassicCarResumeComponent {
  private classicCarQuoterStoreService = inject(ClassicCarQuoterStoreService);
  readonly classicCarQuoterStore =
    this.classicCarQuoterStoreService.state.asReadonly();
  datePipe = inject(DatePipe);
  currencyPipe = inject(CurrencyPipe);
  items: IResumeItem[] = [
    {
      title: 'Marca',
      text: this.classicCarQuoterStore().insurable.brand ?? '',
    },
    {
      title: 'Modelo',
      text: this.classicCarQuoterStore().insurable.model ?? '',
    },

    {
      title: 'Año',
      text: this.classicCarQuoterStore().insurable.year.toString(),
    },
    {
      title: 'Suma Asegurada',
      text: `${this.currencyPipe.transform(
        this.classicCarQuoterStore().insurable.sumInsured,
        'ARS',
        'symbol-narrow',
        '1.2-2',
        'es-AR'
      )}`,
    },
    {
      title: 'Patente',
      text: this.classicCarQuoterStore().insurable.plate ?? '',
    },
    {
      title: 'Motor',
      text: this.classicCarQuoterStore().insurable.motor ?? '',
    },
    {
      title: 'Chasis',
      text: this.classicCarQuoterStore().insurable.chasis ?? '',
    },
  ];
}
